import { TIME_SLOTS } from "./tiers";
import { parseTime } from "./time";

// Expands one "Day|SlotLabel" availability entry to the current hourly
// TIME_SLOTS labels it overlaps. Entries already in the current format pass
// through unchanged; anything that can't be parsed as a time range is left
// as-is rather than silently dropped.
export function remapAvailabilityEntry(entry) {
  const [day, rawSlot] = entry.split("|");
  if (!day || !rawSlot) return [entry];
  if (TIME_SLOTS.includes(rawSlot)) return [entry];
  if (!rawSlot.includes("–")) return [entry];

  const [rawStart, rawEnd] = rawSlot.split("–").map(s => s.trim());
  const start = parseTime(rawStart);
  const end = parseTime(rawEnd);
  if (start == null || end == null) return [entry];

  const overlapping = TIME_SLOTS.filter(slot => {
    const [s, e] = slot.split("–");
    return parseTime(s) < end && parseTime(e) > start;
  }).map(slot => `${day}|${slot}`);

  return overlapping.length > 0 ? overlapping : [entry];
}

export function remapPlayerAvailability(player) {
  const remapped = new Set();
  player.availability.forEach(entry => {
    remapAvailabilityEntry(entry).forEach(e => remapped.add(e));
  });
  return [...remapped];
}

function sameAvailability(a, b) {
  return a.length === b.length && a.every(entry => b.includes(entry));
}

export function hasStaleAvailability(player) {
  return !sameAvailability(remapPlayerAvailability(player), player.availability);
}
